module.exports = __webpack_public_path__ + "files/SPIADI2020 - Réa sink.d701977481203af5f957dc13a83d92e2.pdf";